import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "./components/Sidebar/Sidebar";
import {
  PrivatesRoutes,
  PublicRoutes,
  StaticPagesRoutes,
} from "./NavigationRoutes/NavigationRoutes";
import "./App.css";
import { AuthProvider } from "./context/AuthProvider"; // Import AuthProvider
import { useAuth } from "./context/AuthProvider"; // Import useAuth
import { ThemeProvider } from "./context/ThemeProvider";
import { CreatorCardsProvider } from "./context/Creator/CreatorCardsProvider";
import { CreatorBoosterProvider } from "./context/Creator/CreatorBoostersProvider";
import { CollectorProvider } from "./context/Collector/CollectorBoostersProvider";
import { CollectorCardsProvider } from "./context/Collector/CollectorCardsProvider";
import { CreatorPostProvider } from "./context/Creator/CreatorPostsProvider";
import { FetchedUserBoosterProvider } from "./context/fetchedUser/FetchedUserBoostersProvider";
import { FetchedUserPostProvider } from "./context/fetchedUser/FetchedUserPostsProvider";
import { FetchedUserProvider } from "./context/fetchedUser/FetchedUser";
import { CartProvider } from "./context/CartProvider";
// import Footer from "./components/Footer/Footer";
import RightSidebar from "./components/RightSidebar/RightSidebar";
import { AlertProvider } from "./context/AlertProvider";
import { PrintCartProvider } from "./context/PrintCartProvider";
import BottomNavbar from "./components/BottomNabar/BottomNavbar";
import LoadingIcon from "./components/CssIcon/Loading/LoadingIcon";
import { OpenBoosterProvider } from "./context/OpenBoosterProvider";
import { ExploreProvider } from "./context/ExploreProvider";
import Footer from "./components/Footer/Footer";
import TopNavbar from "./components/TopNavbar/TopNavbar";

const AppContent: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const [hideSidePannel, setHideSidePannel] = useState<boolean>(false);

  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  // const [showLoginModal, setShowLoginModal] = useState(false);

  //TODO add later
  // useEffect(() => {
  //   const handleScroll = () => {
  //     // if (window.scrollY > 400) {
  //     if (window.scrollY > 1) {
  //       setIsScrolled(true);
  //     } else {
  //       setIsScrolled(false);
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  useEffect(() => {
    setIsScrolled(false);

    const mediaQuery = window.matchMedia("(max-width: 800px)");

    const handleResize = () => setHideSidePannel(mediaQuery.matches);

    handleResize(); // Vérifie la taille initiale
    mediaQuery.addEventListener("change", handleResize);

    return () => mediaQuery.removeEventListener("change", handleResize);
  }, []);

  const isAuthPage =
    location.pathname.toLocaleLowerCase() === "/" ||
    location.pathname.toLocaleLowerCase() === "/register" ||
    location.pathname.toLocaleLowerCase() === "/forgot" ||
    location.pathname.toLocaleLowerCase() === "/forgot/reset";

  const isStaticPage =
    location.pathname.toLocaleLowerCase() === "/cgu" ||
    location.pathname.toLocaleLowerCase() === "/cgv" ||
    location.pathname.toLocaleLowerCase() === "/privacy-policy" ||
    location.pathname.toLocaleLowerCase() === "/legal-mentions";

  // const handleLoginClick = () => {
  //   setShowLoginModal(true);
  // };

  const handleRegisterClick = () => {
    navigate("/authentication/register");
  };

  if (loading) {
    return <LoadingIcon />;
  }

  return (
    <>
      {((isAuthPage && user) || !isAuthPage) && <TopNavbar />}

      {!isStaticPage && (
        <div
          className="page-container"
          data-bs-theme="dark" //make light in case of light theme
          data-color-mode="light"
        >
          {((isAuthPage && user) || !isAuthPage) && (
            <>
              {!hideSidePannel && (
                <div className={isScrolled ? "left-panel small" : "left-panel"}>
                  <Sidebar scrolled={isScrolled} />
                </div>
              )}
            </>
          )}
          <div className="main-content">
            <PublicRoutes />

            {/* <PublicRoutes setShowLoginModal={setShowLoginModal} /> */}
            {user && <PrivatesRoutes />}
          </div>
          {user && (
            <div className={isScrolled ? "right-panel small" : "right-panel"}>
              <RightSidebar scrolled={isScrolled} />
              {/* <NotificationButton /> */}
            </div>
          )}
          {!user && !isAuthPage && (
            <div className="right-panel">
              {/* <button onClick={handleLoginClick}>Login</button> */}
              <button onClick={handleRegisterClick}>Register</button>
            </div>
          )}
        </div>
      )}
      {((isAuthPage && user) || !isAuthPage) && <BottomNavbar />}
      <StaticPagesRoutes />
      <Footer />
    </>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <AuthUserContext>
        <AlertProvider>
          <FetchedUserProvider>
            <FetchedProfileContext>
              <AppContent />
            </FetchedProfileContext>
          </FetchedUserProvider>
        </AlertProvider>
      </AuthUserContext>
    </AuthProvider>
  );
};

const AuthUserContext: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <PrintCartProvider>
      <CartProvider>
        <ThemeProvider>
          <CreatorCardsProvider>
            <CreatorBoosterProvider>
              <CollectorProvider>
                <CollectorCardsProvider>
                  <OpenBoosterProvider>
                    <ExploreProvider>
                      <CreatorPostProvider>{children}</CreatorPostProvider>
                    </ExploreProvider>
                  </OpenBoosterProvider>
                </CollectorCardsProvider>
              </CollectorProvider>
            </CreatorBoosterProvider>
          </CreatorCardsProvider>
        </ThemeProvider>
      </CartProvider>
    </PrintCartProvider>
  );
};

const FetchedProfileContext: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <FetchedUserPostProvider>
      <FetchedUserBoosterProvider>{children}</FetchedUserBoosterProvider>
    </FetchedUserPostProvider>
  );
};

export default App;
